import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, inject, signal } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { LAYOUT_HEADER_HEIGHT_PX, LAYOUT_MOBILE_BREAKPOINT_PX } from '../../app.constants';
import { AuthService } from '../../auth/auth.service';
import { HeaderComponent } from '../header/header.component';
import { SidenavComponent } from '../sidenav/sidenav.component';

@Component({
	selector: 'app-layout',
	imports: [HeaderComponent, SidenavComponent, RouterOutlet, MatSidenavModule, MatProgressSpinnerModule],
	templateUrl: './layout.component.html',
	styleUrl: './layout.component.scss'
})
export class LayoutComponent {
	isMobile = false;
	headerHeight = LAYOUT_HEADER_HEIGHT_PX;
	authInitialized = signal<boolean>(false);

	private authService = inject(AuthService);
	loggedIn = this.authService.loggedIn;

	constructor(private breakpointObserver: BreakpointObserver) {
		this.breakpointObserver
			.observe([`(max-width: ${LAYOUT_MOBILE_BREAKPOINT_PX}px)`]) // or [Breakpoints.Handset]
			.subscribe(result => {
				this.isMobile = result.matches;
			});
	}

	async ngOnInit() {
		await this.authService.refreshAuthState();
		this.authInitialized.set(true);
	}
}
